<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay" v-on:click="close(false)"></div>
      <div :class="{modalContent: true}">
        <h4 class="modalTitle">Choose Attachment Type</h4>
        <div class="selectorCnt">
          <div class="selectorItem" v-on:click="close(true, 'dialog')">
            <img src="../assets/007-dialog.png">
            <h4>Dialog</h4>
            <p>Display dialog box with content.</p>
          </div>
          <div class="selectorItem" v-on:click="close(true, 'media')">
            <img src="../assets/005-pdf.png">
            <h4>Media File</h4>
            <p>Document or media from media library.</p>
          </div>
          <div class="selectorItem" v-on:click="close(true, 'link')">
            <img src="../assets/006-link.png">
            <h4>External Link</h4>
            <p>Content that link to another website.</p>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'confirmation',
  data() {
    return {
      show: false,
      next: null,
    };
  },
  methods: {
    open(next) {
      this.show = true;
      this.next = next;
    },
    close(b, o) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b, o);
    },
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 991;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.7);
      z-index: 1;
      // backdrop-filter: saturate(180%) blur(20px);
      opacity: 1;
    }
    .modalContent{
      position: absolute;
      background-color: #fff;
      z-index: 2;
      padding: 30px 80px 10px;
      border-radius: 5px;
      margin-top: -20px;
      overflow: hidden;
      width: 480px;
      .modalTitle{
        padding: 30px 100px 10px;
        font-size: 24px;
        margin: -30px -80px 20px;
        text-align: center;
        font-weight: 600;
      }
      .selectorCnt{
        display: flex;
        flex-wrap: wrap;
        .selectorItem{
          padding: 20px 20px;
          // padding-left: 70px;
          border: #fff 1px solid;
          border-radius: 10px;
          transition: all .2s ease;
          position: relative;
          opacity: .7;
          box-sizing: border-box;
          width: 33.3333%;
          text-align: center;
          margin-bottom: 10px;
          &:hover{
            opacity: 1;
            // border-color: #f5f5f5;
            // box-shadow: 2px 2px 2px rgba(0,0,0,.1);
            cursor: pointer;
            background-color: #f5f5f5;
          }
          h4{
            margin: 0;
            font-size: 16px;
            font-weight: 600;
          }
          p{
            color: #767676;
            font-size: 11px;
          }
          img{
            // position: absolute;
            // left: 20px; top: 50%;
            height: 38px;
            margin-bottom: 8px;
            // margin-top: -15px;
          }
        }
      }
    }
  }
</style>
